// src/App.tsx
import  React, { useState, useEffect  } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import StatsChart from '../components/StatsChart';
import NbBateauxChart from '../components/chart/NbBateauxChart';
import StatCard from '../components/StatCard';
import { BuildingStorefrontIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import InfoGlobalCards from '../components/dashboard/InfoGlobalCards';
import PlacesLibresCards from '../components/dashboard/PlacesLibresCards';
import InfoRevenuCard from '../components/dashboard/InfoRevenuCard'; 
import InfoSoldeCard from '../components/dashboard/InfoSoldeCard'; 
import MapNationalitesCard from '../components/dashboard/MapNationalitesCard';  
import { MasonryGrid, MasonryItem } from '../components/layout/Masonry'; 
import CaMensuelChart from '../components/chart/CaMensuelChart';
import { useSettingsLocal } from '../hooks/useSettingsLocal';
import { mergeWithDefaults } from '../stores/settingsLocal';
import { api } from '../services/api';


export default function Dashboard() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

   const today = new Date().toISOString().split('T')[0]; 
   const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const dateStr = yesterday.toISOString().split('T')[0];

   const { settings, setSettings } = useSettingsLocal();

  // useEffect(() => {
  //   let cancelled = false;
  //   (async () => {
  //     try {
  //       // fetch depuis ton backend (clé ui.dashboard)
  //       const res = await api.get('/settings/ui.dashboard');
  //       if (cancelled) return;
  //       const merged = mergeWithDefaults(res.data?.value ?? {});
  //       // met en localStorage + notifie (setSettings s’en charge)
  //       setSettings(merged);
  //     } catch (e: any) {
  //       // Si 404 (clé absente), on laisse les defaults déjà présents en localStorage
  //       // Sinon tu peux log/alerter si besoin
  //     }
  //   })();
  //   return () => { cancelled = true; };
  // }, [ setSettings]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await api.get('/settings/ui.dashboard');

        if (cancelled) return;

        const merged = mergeWithDefaults(res.data?.value ?? {});
        setSettings(merged);
      } catch (e: any) {
        // 404 = on garde les valeurs locales / defaults
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-svh flex overflow-x-hidden dark:bg-darkMode bg-[#f9fafb]">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <div className="flex flex-col flex-1  lg:ml-64 min-w-0">
        <Header onOpenSidebar={() => setIsSidebarOpen(true)} />

        <main className="flex-1 bg-gray-50 dark:bg-darkMode p-4 pt-16 sm:p-6  sm:pt-16 overflow-x-hidden">
          <MasonryGrid className="auto-rows-min w-full max-w-full grid-cols-1 sm:grid-cols-2 lg:grid-cols-3" rowHeight={8} gap={24} >
          
             {settings.cards.infoGlobal && <InfoGlobalCards date={today} />}
            
            {/* 2) Info Revenu — doit prendre 2 colonnes */}
            {settings.cards.infoRevenu && <MasonryItem colSpanMd={2}>
              <InfoRevenuCard date={dateStr} />
            </MasonryItem>}

            {/* 3) Places libres (une colonne) */}
            {settings.cards.placesLibres && <MasonryItem>
              <PlacesLibresCards date={today} />
            </MasonryItem>}
            
            {settings.cards.infoSolde && <MasonryItem>
              <InfoSoldeCard date={dateStr} />
            </MasonryItem>}

            {settings.cards.caMensuelChart && <MasonryItem colSpanMd={2}>
              <CaMensuelChart  initialMode="factures" />
            </MasonryItem>}
            
           
           {settings.cards.mapNationalites && <MasonryItem colSpanMd={2}>
              <MapNationalitesCard height={360} maxItems={6}  />
            </MasonryItem>}
          </MasonryGrid>

          
        {/* <div className="p-6">
           
            <InfoGlobalCards date={today} />
        </div>

        
        
          <PlacesLibresCards date={today} />
        

         <InfoRevenuCard date={dateStr} /> */}
        
        </main>
      </div>
    </div>
  );
}
